import type * as React from 'react';

export interface RowElementItemProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Se posizionato in un componente RowElement,
   * permette di definire il numero di colonne occupate.
   */
  colSpan?: number;
}
/**
 * Item generico con proprieta di layout colSpan per il RowElement
 */
export function RowElementItem(props: RowElementItemProps) {
  return <div {...props} />;
}
